import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InterceptorInterceptor } from '../interceptor/interceptor.interceptor';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CookieService } from 'ngx-cookie-service';
import { GoogleMapsModule } from '@angular/google-maps';
import { HighchartsChartModule } from 'highcharts-angular';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { CalendarModule } from 'primeng/calendar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxUiLoaderModule } from 'ngx-ui-loader';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FontAwesomeModule,
    GoogleMapsModule,
    BrowserAnimationsModule,
    HighchartsChartModule,
    ButtonModule,
    TooltipModule,
    NgxPaginationModule,
    CalendarModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatTooltipModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({ timeOut: 2000 }),
    NgxUiLoaderModule.forRoot((() => {
      const w = window.innerWidth;
      const fgsSize = w > 3840 ? 120 : w > 2560 ? 100 : w > 1920 ? 80 : w > 1024 ? 60 : 40;
      return {
        text: 'Loading...',
        textColor: '#ffffff',
        bgsColor: '#000000',
        fgsColor: '#ffffff',
        fgsType: 'circle',
        fgsSize,
        pbColor: '#ffffff',
      };
    })()),
    NgxDaterangepickerMd.forRoot({
      cancelLabel: 'Cancel',
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorInterceptor,
      multi: true,
    },
    CookieService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
